import type { Quote } from "@/lib/types";
import { fmtPrice, fmtPct, fmtCompact } from "@/lib/format";
import { cn } from "@/lib/utils";

function Stat({ label, value, valueClass }: { label: string; value: React.ReactNode; valueClass?: string }) {
  return (
    <div className="rounded-lg border bg-card px-3 py-2">
      <div className="text-[10px] uppercase tracking-wide text-muted-foreground">{label}</div>
      <div className={cn("text-base font-semibold tabular-nums", valueClass)}>{value}</div>
    </div>
  );
}

const dash = "—";

export function StatsBar({ quote }: { quote: Quote | null }) {
  const pct = quote?.dayChangePct ?? null;
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-6">
      <Stat
        label="Idag"
        value={pct != null ? fmtPct(pct) : dash}
        valueClass={pct == null ? undefined : pct >= 0 ? "text-emerald-500" : "text-red-500"}
      />
      <Stat label="Volym idag" value={quote?.dayVolume != null ? fmtCompact(quote.dayVolume) : dash} />
      <Stat label="Högst idag" value={quote?.dayHigh != null ? fmtPrice(quote.dayHigh) : dash} />
      <Stat label="Lägst idag" value={quote?.dayLow != null ? fmtPrice(quote.dayLow) : dash} />
      <Stat label="Föreg. stängn." value={quote?.previousClose != null ? fmtPrice(quote.previousClose) : dash} />
      <Stat label="VWAP" value={quote?.vwap != null ? fmtPrice(quote.vwap) : dash} />
    </div>
  );
}
